/**
 * @generated SignedSource<<cf44772cf1cf0a90ec4bcbedc3de9199>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodCreditCardSelected_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCompleted_query">;
  readonly " $fragmentType": "PaymentMethodCreditCardSelected_query";
};
export type PaymentMethodCreditCardSelected_query$key = {
  readonly " $data"?: PaymentMethodCreditCardSelected_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodCreditCardSelected_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodCreditCardSelected_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCompleted_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "97370c29395d060c0321eaf0f5271338";

export default node;
